import React, { useState, useEffect, useRef } from 'react'
import { Download } from 'lucide-react'
import { api } from '../../../lib/api'
import { Button } from '../../../components/ui/button'

export default function YearEndStatements() {
  const [years, setYears] = useState([])
  const [downloadingYear, setDownloadingYear] = useState(null)
  const [error, setError] = useState(false)
  const [loadError, setLoadError] = useState(false)
  const inFlight = useRef(false)

  useEffect(() => {
    let cancelled = false
    api.getGivingStatementYears()
      .then(res => { if (!cancelled) setYears(res?.years ?? []) })
      .catch(() => { if (!cancelled) setLoadError(true) })
    return () => { cancelled = true }
  }, [])

  const handleDownload = async (year) => {
    if (inFlight.current) return
    inFlight.current = true
    setDownloadingYear(year)
    setError(false)
    try {
      const blob = await api.downloadGivingStatement(year)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `claritas-giving-statement-${year}.pdf`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      setTimeout(() => window.URL.revokeObjectURL(url), 0)
    } catch {
      setError(true)
    } finally {
      inFlight.current = false
      setDownloadingYear(null)
    }
  }

  return (
    <div className="bg-white border border-surface-border rounded p-6 mt-6">
      <h2 className="text-lg font-semibold text-charcoal mb-4">Year-end statements</h2>
      {loadError ? (
        <p className="text-sm text-red-600" role="alert">
          We couldn't load your statements.
        </p>
      ) : years.length === 0 ? (
        <p className="text-sm text-charcoal-muted">
          Your statement for a year appears here once that year ends.
        </p>
      ) : (
        <div className="flex flex-wrap gap-3">
          {years.map(year => (
            <Button
              key={year}
              variant="outline"
              onClick={() => handleDownload(year)}
              disabled={downloadingYear !== null}
              aria-label={`Download ${year} giving statement`}
            >
              <Download className="w-4 h-4 mr-2" />
              {year} giving statement
            </Button>
          ))}
        </div>
      )}
      {error && (
        <p className="text-sm text-red-600 mt-3" role="alert">
          We couldn't download that statement. Please try again.
        </p>
      )}
    </div>
  )
}
